module.exports = __webpack_public_path__ + "slider-1-mobile.jpg?b1663bdd391486065378896bfae8c10c";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/slider-1-mobile.jpg
// module id = 305
// module chunks = 0